import React, { Component, Fragment } from 'react';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import Icon from '~/UI/Icon';

import ProductGroupSelectModule from './GroupSelectModule';
import styles from './styles.less';

interface Props {
	group: UserProductGroup;
	displayModule: boolean;
	displayParentName: boolean;
}

export default class GroupSelectOption extends Component<Props> {
	static defaultProps = {
		displayParentName: false,
	};

	render() {
		const { group, displayModule, displayParentName } = this.props;

		return (
			<Fragment>
				{group.isProductList() ? (
					<span className={styles.listBadge}>List</span>
				) : (
					<span className={styles.folderBadge}>Folder</span>
				)}
				<span title={group.name}>
					{displayParentName && group.parent !== null ? (
						<Fragment>
							{group.parent.name} <Icon name='next' />
						</Fragment>
					) : null}
					{group.name}
				</span>
				{displayModule ? <ProductGroupSelectModule group={group} style={styles.module} /> : null}
			</Fragment>
		);
	}
}
